export const timezoneFlagMap = {
  "Africa/Abidjan": "\ud83c\udde8\ud83c\uddee",
  "Africa/Accra": "\ud83c\uddec\ud83c\udded",
  "Africa/Addis_Ababa": "\ud83c\uddea\ud83c\uddf9",
  "Africa/Algiers": "\ud83c\udde9\ud83c\uddff",
  "Africa/Asmara": "\ud83c\uddea\ud83c\uddf7",
  "Africa/Bamako": "\ud83c\uddf2\ud83c\uddf1",
  "Africa/Bangui": "\ud83c\udde8\ud83c\uddeb",
  "Africa/Banjul": "\ud83c\uddec\ud83c\uddf2",
  "Africa/Bissau": "\ud83c\uddec\ud83c\uddfc",
  "Africa/Blantyre": "\ud83c\uddf2\ud83c\uddfc",
  "Africa/Brazzaville": "\ud83c\udde8\ud83c\uddec",
  "Africa/Bujumbura": "\ud83c\udde7\ud83c\uddee",
  "Africa/Cairo": "\ud83c\uddea\ud83c\uddec",
  "Africa/Casablanca": "\ud83c\uddf2\ud83c\udde6",
  "Africa/Ceuta": "\ud83c\uddea\ud83c\uddf8",
  "Africa/Conakry": "\ud83c\uddec\ud83c\uddf3",
  "Africa/Dakar": "\ud83c\uddf8\ud83c\uddf3",
  "Africa/Dar_es_Salaam": "\ud83c\uddf9\ud83c\uddff",
  "Africa/Djibouti": "\ud83c\udde9\ud83c\uddef",
  "Africa/Douala": "\ud83c\udde8\ud83c\uddf2",
  "Africa/El_Aaiun": "\ud83c\uddea\ud83c\udded",
  "Africa/Freetown": "\ud83c\uddf8\ud83c\uddf1",
  "Africa/Gaborone": "\ud83c\udde7\ud83c\uddfc",
  "Africa/Harare": "\ud83c\uddff\ud83c\uddfc",
  "Africa/Johannesburg": "\ud83c\uddff\ud83c\udde6",
  "Africa/Juba": "\ud83c\uddf8\ud83c\uddf8",
  "Africa/Kampala": "\ud83c\uddfa\ud83c\uddec",
  "Africa/Khartoum": "\ud83c\uddf8\ud83c\udde9",
  "Africa/Kigali": "\ud83c\uddf7\ud83c\uddfc",
  "Africa/Kinshasa": "\ud83c\udde8\ud83c\udde9",
  "Africa/Lagos": "\ud83c\uddf3\ud83c\uddec",
  "Africa/Libreville": "\ud83c\uddec\ud83c\udde6",
  "Africa/Lome": "\ud83c\uddf9\ud83c\uddec",
  "Africa/Luanda": "\ud83c\udde6\ud83c\uddf4",
  "Africa/Lubumbashi": "\ud83c\udde8\ud83c\udde9",
  "Africa/Lusaka": "\ud83c\uddff\ud83c\uddf2",
  "Africa/Malabo": "\ud83c\uddec\ud83c\uddf6",
  "Africa/Maputo": "\ud83c\uddf2\ud83c\uddff",
  "Africa/Maseru": "\ud83c\uddf1\ud83c\uddf8",
  "Africa/Mbabane": "\ud83c\uddf8\ud83c\uddff",
  "Africa/Mogadishu": "\ud83c\uddf8\ud83c\uddf4",
  "Africa/Monrovia": "\ud83c\uddf1\ud83c\uddf7",
  "Africa/Nairobi": "\ud83c\uddf0\ud83c\uddea",
  "Africa/Ndjamena": "\ud83c\uddf9\ud83c\udde9",
  "Africa/Niamey": "\ud83c\uddf3\ud83c\uddea",
  "Africa/Nouakchott": "\ud83c\uddf2\ud83c\uddf7",
  "Africa/Ouagadougou": "\ud83c\udde7\ud83c\uddeb",
  "Africa/Porto-Novo": "\ud83c\udde7\ud83c\uddef",
  "Africa/Sao_Tome": "\ud83c\uddf8\ud83c\uddf9",
  "Africa/Tripoli": "\ud83c\uddf1\ud83c\uddfe",
  "Africa/Tunis": "\ud83c\uddf9\ud83c\uddf3",
  "Africa/Windhoek": "\ud83c\uddf3\ud83c\udde6",
  "America/Adak": "\ud83c\uddfa\ud83c\uddf8",
  "America/Anchorage": "\ud83c\uddfa\ud83c\uddf8",
  "America/Anguilla": "\ud83c\udde6\ud83c\uddee",
  "America/Antigua": "\ud83c\udde6\ud83c\uddec",
  "America/Araguaina": "\ud83c\udde7\ud83c\uddf7",
  "America/Argentina/Buenos_Aires": "\ud83c\udde6\ud83c\uddf7",
  "America/Argentina/Catamarca": "\ud83c\udde6\ud83c\uddf7",
  "America/Argentina/Cordoba": "\ud83c\udde6\ud83c\uddf7",
  "America/Argentina/Jujuy": "\ud83c\udde6\ud83c\uddf7",
  "America/Argentina/La_Rioja": "\ud83c\udde6\ud83c\uddf7",
  "America/Argentina/Mendoza": "\ud83c\udde6\ud83c\uddf7",
  "America/Argentina/Rio_Gallegos": "\ud83c\udde6\ud83c\uddf7",
  "America/Argentina/Salta": "\ud83c\udde6\ud83c\uddf7",
  "America/Argentina/San_Juan": "\ud83c\udde6\ud83c\uddf7",
  "America/Argentina/San_Luis": "\ud83c\udde6\ud83c\uddf7",
  "America/Argentina/Tucuman": "\ud83c\udde6\ud83c\uddf7",
  "America/Argentina/Ushuaia": "\ud83c\udde6\ud83c\uddf7",
  "America/Aruba": "\ud83c\udde6\ud83c\uddfc",
  "America/Asuncion": "\ud83c\uddf5\ud83c\uddfe",
  "America/Atikokan": "\ud83c\udde8\ud83c\udde6",
  "America/Bahia": "\ud83c\udde7\ud83c\uddf7",
  "America/Bahia_Banderas": "\ud83c\uddf2\ud83c\uddfd",
  "America/Barbados": "\ud83c\udde7\ud83c\udde7",
  "America/Belem": "\ud83c\udde7\ud83c\uddf7",
  "America/Belize": "\ud83c\udde7\ud83c\uddff",
  "America/Blanc-Sablon": "\ud83c\udde8\ud83c\udde6",
  "America/Boa_Vista": "\ud83c\udde7\ud83c\uddf7",
  "America/Bogota": "\ud83c\udde8\ud83c\uddf4",
  "America/Boise": "\ud83c\uddfa\ud83c\uddf8",
  "America/Cambridge_Bay": "\ud83c\udde8\ud83c\udde6",
  "America/Campo_Grande": "\ud83c\udde7\ud83c\uddf7",
  "America/Cancun": "\ud83c\uddf2\ud83c\uddfd",
  "America/Caracas": "\ud83c\uddfb\ud83c\uddea",
  "America/Cayenne": "\ud83c\uddec\ud83c\uddeb",
  "America/Cayman": "\ud83c\uddf0\ud83c\uddfe",
  "America/Chicago": "\ud83c\uddfa\ud83c\uddf8",
  "America/Chihuahua": "\ud83c\uddf2\ud83c\uddfd",
  "America/Ciudad_Juarez": "\ud83c\uddf2\ud83c\uddfd",
  "America/Costa_Rica": "\ud83c\udde8\ud83c\uddf7",
  "America/Coyhaique": "\ud83c\udde8\ud83c\uddf1",
  "America/Creston": "\ud83c\udde8\ud83c\udde6",
  "America/Cuiaba": "\ud83c\udde7\ud83c\uddf7",
  "America/Curacao": "\ud83c\udde8\ud83c\uddfc",
  "America/Danmarkshavn": "\ud83c\uddec\ud83c\uddf1",
  "America/Dawson": "\ud83c\udde8\ud83c\udde6",
  "America/Dawson_Creek": "\ud83c\udde8\ud83c\udde6",
  "America/Denver": "\ud83c\uddfa\ud83c\uddf8",
  "America/Detroit": "\ud83c\uddfa\ud83c\uddf8",
  "America/Dominica": "\ud83c\udde9\ud83c\uddf2",
  "America/Edmonton": "\ud83c\udde8\ud83c\udde6",
  "America/Eirunepe": "\ud83c\udde7\ud83c\uddf7",
  "America/El_Salvador": "\ud83c\uddf8\ud83c\uddfb",
  "America/Fort_Nelson": "\ud83c\udde8\ud83c\udde6",
  "America/Fortaleza": "\ud83c\udde7\ud83c\uddf7",
  "America/Glace_Bay": "\ud83c\udde8\ud83c\udde6",
  "America/Goose_Bay": "\ud83c\udde8\ud83c\udde6",
  "America/Grand_Turk": "\ud83c\uddf9\ud83c\udde8",
  "America/Grenada": "\ud83c\uddec\ud83c\udde9",
  "America/Guadeloupe": "\ud83c\uddec\ud83c\uddf5",
  "America/Guatemala": "\ud83c\uddec\ud83c\uddf9",
  "America/Guayaquil": "\ud83c\uddea\ud83c\udde8",
  "America/Guyana": "\ud83c\uddec\ud83c\uddfe",
  "America/Halifax": "\ud83c\udde8\ud83c\udde6",
  "America/Havana": "\ud83c\udde8\ud83c\uddfa",
  "America/Hermosillo": "\ud83c\uddf2\ud83c\uddfd",
  "America/Indiana/Indianapolis": "\ud83c\uddfa\ud83c\uddf8",
  "America/Indiana/Knox": "\ud83c\uddfa\ud83c\uddf8",
  "America/Indiana/Marengo": "\ud83c\uddfa\ud83c\uddf8",
  "America/Indiana/Petersburg": "\ud83c\uddfa\ud83c\uddf8",
  "America/Indiana/Tell_City": "\ud83c\uddfa\ud83c\uddf8",
  "America/Indiana/Vevay": "\ud83c\uddfa\ud83c\uddf8",
  "America/Indiana/Vincennes": "\ud83c\uddfa\ud83c\uddf8",
  "America/Indiana/Winamac": "\ud83c\uddfa\ud83c\uddf8",
  "America/Inuvik": "\ud83c\udde8\ud83c\udde6",
  "America/Iqaluit": "\ud83c\udde8\ud83c\udde6",
  "America/Jamaica": "\ud83c\uddef\ud83c\uddf2",
  "America/Juneau": "\ud83c\uddfa\ud83c\uddf8",
  "America/Kentucky/Louisville": "\ud83c\uddfa\ud83c\uddf8",
  "America/Kentucky/Monticello": "\ud83c\uddfa\ud83c\uddf8",
  "America/Kralendijk": "\ud83c\udde7\ud83c\uddf6",
  "America/La_Paz": "\ud83c\udde7\ud83c\uddf4",
  "America/Lima": "\ud83c\uddf5\ud83c\uddea",
  "America/Los_Angeles": "\ud83c\uddfa\ud83c\uddf8",
  "America/Lower_Princes": "\ud83c\uddf8\ud83c\uddfd",
  "America/Maceio": "\ud83c\udde7\ud83c\uddf7",
  "America/Managua": "\ud83c\uddf3\ud83c\uddee",
  "America/Manaus": "\ud83c\udde7\ud83c\uddf7",
  "America/Marigot": "\ud83c\uddf2\ud83c\uddeb",
  "America/Martinique": "\ud83c\uddf2\ud83c\uddf6",
  "America/Matamoros": "\ud83c\uddf2\ud83c\uddfd",
  "America/Mazatlan": "\ud83c\uddf2\ud83c\uddfd",
  "America/Menominee": "\ud83c\uddfa\ud83c\uddf8",
  "America/Merida": "\ud83c\uddf2\ud83c\uddfd",
  "America/Metlakatla": "\ud83c\uddfa\ud83c\uddf8",
  "America/Mexico_City": "\ud83c\uddf2\ud83c\uddfd",
  "America/Miquelon": "\ud83c\uddf5\ud83c\uddf2",
  "America/Moncton": "\ud83c\udde8\ud83c\udde6",
  "America/Monterrey": "\ud83c\uddf2\ud83c\uddfd",
  "America/Montevideo": "\ud83c\uddfa\ud83c\uddfe",
  "America/Montserrat": "\ud83c\uddf2\ud83c\uddf8",
  "America/Nassau": "\ud83c\udde7\ud83c\uddf8",
  "America/New_York": "\ud83c\uddfa\ud83c\uddf8",
  "America/Nome": "\ud83c\uddfa\ud83c\uddf8",
  "America/Noronha": "\ud83c\udde7\ud83c\uddf7",
  "America/North_Dakota/Beulah": "\ud83c\uddfa\ud83c\uddf8",
  "America/North_Dakota/Center": "\ud83c\uddfa\ud83c\uddf8",
  "America/North_Dakota/New_Salem": "\ud83c\uddfa\ud83c\uddf8",
  "America/Nuuk": "\ud83c\uddec\ud83c\uddf1",
  "America/Ojinaga": "\ud83c\uddf2\ud83c\uddfd",
  "America/Panama": "\ud83c\uddf5\ud83c\udde6",
  "America/Paramaribo": "\ud83c\uddf8\ud83c\uddf7",
  "America/Phoenix": "\ud83c\uddfa\ud83c\uddf8",
  "America/Port-au-Prince": "\ud83c\udded\ud83c\uddf9",
  "America/Port_of_Spain": "\ud83c\uddf9\ud83c\uddf9",
  "America/Porto_Velho": "\ud83c\udde7\ud83c\uddf7",
  "America/Puerto_Rico": "\ud83c\uddf5\ud83c\uddf7",
  "America/Punta_Arenas": "\ud83c\udde8\ud83c\uddf1",
  "America/Rankin_Inlet": "\ud83c\udde8\ud83c\udde6",
  "America/Recife": "\ud83c\udde7\ud83c\uddf7",
  "America/Regina": "\ud83c\udde8\ud83c\udde6",
  "America/Resolute": "\ud83c\udde8\ud83c\udde6",
  "America/Rio_Branco": "\ud83c\udde7\ud83c\uddf7",
  "America/Santarem": "\ud83c\udde7\ud83c\uddf7",
  "America/Santiago": "\ud83c\udde8\ud83c\uddf1",
  "America/Santo_Domingo": "\ud83c\udde9\ud83c\uddf4",
  "America/Sao_Paulo": "\ud83c\udde7\ud83c\uddf7",
  "America/Scoresbysund": "\ud83c\uddec\ud83c\uddf1",
  "America/Sitka": "\ud83c\uddfa\ud83c\uddf8",
  "America/St_Barthelemy": "\ud83c\udde7\ud83c\uddf1",
  "America/St_Johns": "\ud83c\udde8\ud83c\udde6",
  "America/St_Kitts": "\ud83c\uddf0\ud83c\uddf3",
  "America/St_Lucia": "\ud83c\uddf1\ud83c\udde8",
  "America/St_Thomas": "\ud83c\uddfb\ud83c\uddee",
  "America/St_Vincent": "\ud83c\uddfb\ud83c\udde8",
  "America/Swift_Current": "\ud83c\udde8\ud83c\udde6",
  "America/Tegucigalpa": "\ud83c\udded\ud83c\uddf3",
  "America/Thule": "\ud83c\uddec\ud83c\uddf1",
  "America/Tijuana": "\ud83c\uddf2\ud83c\uddfd",
  "America/Toronto": "\ud83c\udde8\ud83c\udde6",
  "America/Tortola": "\ud83c\uddfb\ud83c\uddec",
  "America/Vancouver": "\ud83c\udde8\ud83c\udde6",
  "America/Whitehorse": "\ud83c\udde8\ud83c\udde6",
  "America/Winnipeg": "\ud83c\udde8\ud83c\udde6",
  "America/Yakutat": "\ud83c\uddfa\ud83c\uddf8",
  "Antarctica/Casey": "\ud83c\udde6\ud83c\uddf6",
  "Antarctica/Davis": "\ud83c\udde6\ud83c\uddf6",
  "Antarctica/DumontDUrville": "\ud83c\udde6\ud83c\uddf6",
  "Antarctica/Macquarie": "\ud83c\udde6\ud83c\uddfa",
  "Antarctica/Mawson": "\ud83c\udde6\ud83c\uddf6",
  "Antarctica/McMurdo": "\ud83c\udde6\ud83c\uddf6",
  "Antarctica/Palmer": "\ud83c\udde6\ud83c\uddf6",
  "Antarctica/Rothera": "\ud83c\udde6\ud83c\uddf6",
  "Antarctica/Syowa": "\ud83c\udde6\ud83c\uddf6",
  "Antarctica/Troll": "\ud83c\udde6\ud83c\uddf6",
  "Antarctica/Vostok": "\ud83c\udde6\ud83c\uddf6",
  "Arctic/Longyearbyen": "\ud83c\uddf8\ud83c\uddef",
  "Asia/Aden": "\ud83c\uddfe\ud83c\uddea",
  "Asia/Almaty": "\ud83c\uddf0\ud83c\uddff",
  "Asia/Amman": "\ud83c\uddef\ud83c\uddf4",
  "Asia/Anadyr": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Aqtau": "\ud83c\uddf0\ud83c\uddff",
  "Asia/Aqtobe": "\ud83c\uddf0\ud83c\uddff",
  "Asia/Ashgabat": "\ud83c\uddf9\ud83c\uddf2",
  "Asia/Atyrau": "\ud83c\uddf0\ud83c\uddff",
  "Asia/Baghdad": "\ud83c\uddee\ud83c\uddf6",
  "Asia/Bahrain": "\ud83c\udde7\ud83c\udded",
  "Asia/Baku": "\ud83c\udde6\ud83c\uddff",
  "Asia/Bangkok": "\ud83c\uddf9\ud83c\udded",
  "Asia/Barnaul": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Beirut": "\ud83c\uddf1\ud83c\udde7",
  "Asia/Bishkek": "\ud83c\uddf0\ud83c\uddec",
  "Asia/Brunei": "\ud83c\udde7\ud83c\uddf3",
  "Asia/Chita": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Colombo": "\ud83c\uddf1\ud83c\uddf0",
  "Asia/Damascus": "\ud83c\uddf8\ud83c\uddfe",
  "Asia/Dhaka": "\ud83c\udde7\ud83c\udde9",
  "Asia/Dili": "\ud83c\uddf9\ud83c\uddf1",
  "Asia/Dubai": "\ud83c\udde6\ud83c\uddea",
  "Asia/Dushanbe": "\ud83c\uddf9\ud83c\uddef",
  "Asia/Famagusta": "\ud83c\udde8\ud83c\uddfe",
  "Asia/Gaza": "\ud83c\uddf5\ud83c\uddf8",
  "Asia/Hebron": "\ud83c\uddf5\ud83c\uddf8",
  "Asia/Ho_Chi_Minh": "\ud83c\uddfb\ud83c\uddf3",
  "Asia/Hong_Kong": "\ud83c\udded\ud83c\uddf0",
  "Asia/Hovd": "\ud83c\uddf2\ud83c\uddf3",
  "Asia/Irkutsk": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Jakarta": "\ud83c\uddee\ud83c\udde9",
  "Asia/Jayapura": "\ud83c\uddee\ud83c\udde9",
  "Asia/Jerusalem": "\ud83c\uddee\ud83c\uddf1",
  "Asia/Kabul": "\ud83c\udde6\ud83c\uddeb",
  "Asia/Kamchatka": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Karachi": "\ud83c\uddf5\ud83c\uddf0",
  "Asia/Kathmandu": "\ud83c\uddf3\ud83c\uddf5",
  "Asia/Khandyga": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Kolkata": "\ud83c\uddee\ud83c\uddf3",
  "Asia/Krasnoyarsk": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Kuala_Lumpur": "\ud83c\uddf2\ud83c\uddfe",
  "Asia/Kuching": "\ud83c\uddf2\ud83c\uddfe",
  "Asia/Kuwait": "\ud83c\uddf0\ud83c\uddfc",
  "Asia/Macau": "\ud83c\uddf2\ud83c\uddf4",
  "Asia/Magadan": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Makassar": "\ud83c\uddee\ud83c\udde9",
  "Asia/Manila": "\ud83c\uddf5\ud83c\udded",
  "Asia/Muscat": "\ud83c\uddf4\ud83c\uddf2",
  "Asia/Nicosia": "\ud83c\udde8\ud83c\uddfe",
  "Asia/Novokuznetsk": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Novosibirsk": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Omsk": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Oral": "\ud83c\uddf0\ud83c\uddff",
  "Asia/Phnom_Penh": "\ud83c\uddf0\ud83c\udded",
  "Asia/Pontianak": "\ud83c\uddee\ud83c\udde9",
  "Asia/Pyongyang": "\ud83c\uddf0\ud83c\uddf5",
  "Asia/Qatar": "\ud83c\uddf6\ud83c\udde6",
  "Asia/Qostanay": "\ud83c\uddf0\ud83c\uddff",
  "Asia/Qyzylorda": "\ud83c\uddf0\ud83c\uddff",
  "Asia/Riyadh": "\ud83c\uddf8\ud83c\udde6",
  "Asia/Sakhalin": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Samarkand": "\ud83c\uddfa\ud83c\uddff",
  "Asia/Seoul": "\ud83c\uddf0\ud83c\uddf7",
  "Asia/Shanghai": "\ud83c\udde8\ud83c\uddf3",
  "Asia/Singapore": "\ud83c\uddf8\ud83c\uddec",
  "Asia/Srednekolymsk": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Taipei": "\ud83c\uddf9\ud83c\uddfc",
  "Asia/Tashkent": "\ud83c\uddfa\ud83c\uddff",
  "Asia/Tbilisi": "\ud83c\uddec\ud83c\uddea",
  "Asia/Tehran": "\ud83c\uddee\ud83c\uddf7",
  "Asia/Thimphu": "\ud83c\udde7\ud83c\uddf9",
  "Asia/Tokyo": "\ud83c\uddef\ud83c\uddf5",
  "Asia/Tomsk": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Ulaanbaatar": "\ud83c\uddf2\ud83c\uddf3",
  "Asia/Urumqi": "\ud83c\udde8\ud83c\uddf3",
  "Asia/Ust-Nera": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Vientiane": "\ud83c\uddf1\ud83c\udde6",
  "Asia/Vladivostok": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Yakutsk": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Yangon": "\ud83c\uddf2\ud83c\uddf2",
  "Asia/Yekaterinburg": "\ud83c\uddf7\ud83c\uddfa",
  "Asia/Yerevan": "\ud83c\udde6\ud83c\uddf2",
  "Atlantic/Azores": "\ud83c\uddf5\ud83c\uddf9",
  "Atlantic/Bermuda": "\ud83c\udde7\ud83c\uddf2",
  "Atlantic/Canary": "\ud83c\uddea\ud83c\uddf8",
  "Atlantic/Cape_Verde": "\ud83c\udde8\ud83c\uddfb",
  "Atlantic/Faroe": "\ud83c\uddeb\ud83c\uddf4",
  "Atlantic/Madeira": "\ud83c\uddf5\ud83c\uddf9",
  "Atlantic/Reykjavik": "\ud83c\uddee\ud83c\uddf8",
  "Atlantic/South_Georgia": "\ud83c\uddec\ud83c\uddf8",
  "Atlantic/St_Helena": "\ud83c\uddf8\ud83c\udded",
  "Atlantic/Stanley": "\ud83c\uddeb\ud83c\uddf0",
  "Australia/Adelaide": "\ud83c\udde6\ud83c\uddfa",
  "Australia/Brisbane": "\ud83c\udde6\ud83c\uddfa",
  "Australia/Broken_Hill": "\ud83c\udde6\ud83c\uddfa",
  "Australia/Darwin": "\ud83c\udde6\ud83c\uddfa",
  "Australia/Eucla": "\ud83c\udde6\ud83c\uddfa",
  "Australia/Hobart": "\ud83c\udde6\ud83c\uddfa",
  "Australia/Lindeman": "\ud83c\udde6\ud83c\uddfa",
  "Australia/Lord_Howe": "\ud83c\udde6\ud83c\uddfa",
  "Australia/Melbourne": "\ud83c\udde6\ud83c\uddfa",
  "Australia/Perth": "\ud83c\udde6\ud83c\uddfa",
  "Australia/Sydney": "\ud83c\udde6\ud83c\uddfa",
  "Europe/Amsterdam": "\ud83c\uddf3\ud83c\uddf1",
  "Europe/Andorra": "\ud83c\udde6\ud83c\udde9",
  "Europe/Astrakhan": "\ud83c\uddf7\ud83c\uddfa",
  "Europe/Athens": "\ud83c\uddec\ud83c\uddf7",
  "Europe/Belgrade": "\ud83c\uddf7\ud83c\uddf8",
  "Europe/Berlin": "\ud83c\udde9\ud83c\uddea",
  "Europe/Bratislava": "\ud83c\uddf8\ud83c\uddf0",
  "Europe/Brussels": "\ud83c\udde7\ud83c\uddea",
  "Europe/Bucharest": "\ud83c\uddf7\ud83c\uddf4",
  "Europe/Budapest": "\ud83c\udded\ud83c\uddfa",
  "Europe/Busingen": "\ud83c\udde9\ud83c\uddea",
  "Europe/Chisinau": "\ud83c\uddf2\ud83c\udde9",
  "Europe/Copenhagen": "\ud83c\udde9\ud83c\uddf0",
  "Europe/Dublin": "\ud83c\uddee\ud83c\uddea",
  "Europe/Gibraltar": "\ud83c\uddec\ud83c\uddee",
  "Europe/Guernsey": "\ud83c\uddec\ud83c\uddec",
  "Europe/Helsinki": "\ud83c\uddeb\ud83c\uddee",
  "Europe/Isle_of_Man": "\ud83c\uddee\ud83c\uddf2",
  "Europe/Istanbul": "\ud83c\uddf9\ud83c\uddf7",
  "Europe/Jersey": "\ud83c\uddef\ud83c\uddea",
  "Europe/Kaliningrad": "\ud83c\uddf7\ud83c\uddfa",
  "Europe/Kirov": "\ud83c\uddf7\ud83c\uddfa",
  "Europe/Kyiv": "\ud83c\uddfa\ud83c\udde6",
  "Europe/Lisbon": "\ud83c\uddf5\ud83c\uddf9",
  "Europe/Ljubljana": "\ud83c\uddf8\ud83c\uddee",
  "Europe/London": "\ud83c\uddec\ud83c\udde7",
  "Europe/Luxembourg": "\ud83c\uddf1\ud83c\uddfa",
  "Europe/Madrid": "\ud83c\uddea\ud83c\uddf8",
  "Europe/Malta": "\ud83c\uddf2\ud83c\uddf9",
  "Europe/Mariehamn": "\ud83c\udde6\ud83c\uddfd",
  "Europe/Minsk": "\ud83c\udde7\ud83c\uddfe",
  "Europe/Monaco": "\ud83c\uddf2\ud83c\udde8",
  "Europe/Moscow": "\ud83c\uddf7\ud83c\uddfa",
  "Europe/Oslo": "\ud83c\uddf3\ud83c\uddf4",
  "Europe/Paris": "\ud83c\uddeb\ud83c\uddf7",
  "Europe/Podgorica": "\ud83c\uddf2\ud83c\uddea",
  "Europe/Prague": "\ud83c\udde8\ud83c\uddff",
  "Europe/Riga": "\ud83c\uddf1\ud83c\uddfb",
  "Europe/Rome": "\ud83c\uddee\ud83c\uddf9",
  "Europe/Samara": "\ud83c\uddf7\ud83c\uddfa",
  "Europe/San_Marino": "\ud83c\uddf8\ud83c\uddf2",
  "Europe/Sarajevo": "\ud83c\udde7\ud83c\udde6",
  "Europe/Saratov": "\ud83c\uddf7\ud83c\uddfa",
  "Europe/Simferopol": "\ud83c\uddfa\ud83c\udde6",
  "Europe/Skopje": "\ud83c\uddf2\ud83c\uddf0",
  "Europe/Sofia": "\ud83c\udde7\ud83c\uddec",
  "Europe/Stockholm": "\ud83c\uddf8\ud83c\uddea",
  "Europe/Tallinn": "\ud83c\uddea\ud83c\uddea",
  "Europe/Tirane": "\ud83c\udde6\ud83c\uddf1",
  "Europe/Ulyanovsk": "\ud83c\uddf7\ud83c\uddfa",
  "Europe/Vaduz": "\ud83c\uddf1\ud83c\uddee",
  "Europe/Vatican": "\ud83c\uddfb\ud83c\udde6",
  "Europe/Vienna": "\ud83c\udde6\ud83c\uddf9",
  "Europe/Vilnius": "\ud83c\uddf1\ud83c\uddf9",
  "Europe/Volgograd": "\ud83c\uddf7\ud83c\uddfa",
  "Europe/Warsaw": "\ud83c\uddf5\ud83c\uddf1",
  "Europe/Zagreb": "\ud83c\udded\ud83c\uddf7",
  "Europe/Zurich": "\ud83c\udde8\ud83c\udded",
  "Indian/Antananarivo": "\ud83c\uddf2\ud83c\uddec",
  "Indian/Chagos": "\ud83c\uddee\ud83c\uddf4",
  "Indian/Christmas": "\ud83c\udde8\ud83c\uddfd",
  "Indian/Cocos": "\ud83c\udde8\ud83c\udde8",
  "Indian/Comoro": "\ud83c\uddf0\ud83c\uddf2",
  "Indian/Kerguelen": "\ud83c\uddf9\ud83c\uddeb",
  "Indian/Mahe": "\ud83c\uddf8\ud83c\udde8",
  "Indian/Maldives": "\ud83c\uddf2\ud83c\uddfb",
  "Indian/Mauritius": "\ud83c\uddf2\ud83c\uddfa",
  "Indian/Mayotte": "\ud83c\uddfe\ud83c\uddf9",
  "Indian/Reunion": "\ud83c\uddf7\ud83c\uddea",
  "Pacific/Apia": "\ud83c\uddfc\ud83c\uddf8",
  "Pacific/Auckland": "\ud83c\uddf3\ud83c\uddff",
  "Pacific/Bougainville": "\ud83c\uddf5\ud83c\uddec",
  "Pacific/Chatham": "\ud83c\uddf3\ud83c\uddff",
  "Pacific/Chuuk": "\ud83c\uddeb\ud83c\uddf2",
  "Pacific/Easter": "\ud83c\udde8\ud83c\uddf1",
  "Pacific/Efate": "\ud83c\uddfb\ud83c\uddfa",
  "Pacific/Fakaofo": "\ud83c\uddf9\ud83c\uddf0",
  "Pacific/Fiji": "\ud83c\uddeb\ud83c\uddef",
  "Pacific/Funafuti": "\ud83c\uddf9\ud83c\uddfb",
  "Pacific/Galapagos": "\ud83c\uddea\ud83c\udde8",
  "Pacific/Gambier": "\ud83c\uddf5\ud83c\uddeb",
  "Pacific/Guadalcanal": "\ud83c\uddf8\ud83c\udde7",
  "Pacific/Guam": "\ud83c\uddec\ud83c\uddfa",
  "Pacific/Honolulu": "\ud83c\uddfa\ud83c\uddf8",
  "Pacific/Kanton": "\ud83c\uddf0\ud83c\uddee",
  "Pacific/Kiritimati": "\ud83c\uddf0\ud83c\uddee",
  "Pacific/Kosrae": "\ud83c\uddeb\ud83c\uddf2",
  "Pacific/Kwajalein": "\ud83c\uddf2\ud83c\udded",
  "Pacific/Majuro": "\ud83c\uddf2\ud83c\udded",
  "Pacific/Marquesas": "\ud83c\uddf5\ud83c\uddeb",
  "Pacific/Midway": "\ud83c\uddfa\ud83c\uddf2",
  "Pacific/Nauru": "\ud83c\uddf3\ud83c\uddf7",
  "Pacific/Niue": "\ud83c\uddf3\ud83c\uddfa",
  "Pacific/Norfolk": "\ud83c\uddf3\ud83c\uddeb",
  "Pacific/Noumea": "\ud83c\uddf3\ud83c\udde8",
  "Pacific/Pago_Pago": "\ud83c\udde6\ud83c\uddf8",
  "Pacific/Palau": "\ud83c\uddf5\ud83c\uddfc",
  "Pacific/Pitcairn": "\ud83c\uddf5\ud83c\uddf3",
  "Pacific/Pohnpei": "\ud83c\uddeb\ud83c\uddf2",
  "Pacific/Port_Moresby": "\ud83c\uddf5\ud83c\uddec",
  "Pacific/Rarotonga": "\ud83c\udde8\ud83c\uddf0",
  "Pacific/Saipan": "\ud83c\uddf2\ud83c\uddf5",
  "Pacific/Tahiti": "\ud83c\uddf5\ud83c\uddeb",
  "Pacific/Tarawa": "\ud83c\uddf0\ud83c\uddee",
  "Pacific/Tongatapu": "\ud83c\uddf9\ud83c\uddf4",
  "Pacific/Wake": "\ud83c\uddfa\ud83c\uddf2",
  "Pacific/Wallis": "\ud83c\uddfc\ud83c\uddeb"
};